import React from 'react';
import TextInput from 'src/ui/library/TextInput';
import TextMask from './TextMask';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

class NumberControl extends React.Component {
  state = {
    value: this.props.value || '',
  };

  handleChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    this.setState({
      value: event.target.value,
    });
  };

  renderNumberControl = () => {
    const { onChange, value, helpText, ...otherProps } = this.props;
    const propsWithInputProps = {
      ...otherProps,
      onChange: this.handleChange,
      InputProps: {
        inputComponent: TextMask,
        value: this.state.value,
      },
    };
    return <TextInput {...propsWithInputProps} />;
  };

  render() {
    const { helpText } = this.props;

    let component = this.renderNumberControl();

    if (helpText) {
      component = (
        <InfoTooltip toolTipText={helpText} labelText={component} className="number-tooltip" labelClassName="number-tooltip-label" />
      );
    }

    return component;
  }
}

export default WithHeader(NumberControl);
